import * as Ariakit from '@ariakit/react';
import { forwardRef } from '@wordpress/element';
import { useCompositeContext, useCompositeGroupContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompositeGroupLabel = forwardRef(function CompositeGroupLabel(props, ref) {
  const context = useCompositeContext();
  const isWithinGroup = useCompositeGroupContext();
  if (!isWithinGroup) {
    throw new Error('Composite.GroupLabel can only be rendered inside Composite.Group.');
  }

  // @ts-expect-error The store prop is undocumented and only used by the
  // legacy compat layer. The `store` prop is documented, but its type is
  // obfuscated to discourage its use outside of the component's internals.
  const store = props.store ?? context.store;
  return /*#__PURE__*/_jsx(Ariakit.CompositeGroupLabel, {
    store: store,
    ...props,
    ref: ref
  });
});